<template>
  <div>
    <div id="contacts-dropdown">
      <v-autocomplete
        v-model="contactTicketId"
        :items="contactList.list"
        label="Contacts"
        item-value="id"
        outlined
        clearable
        @click:clear="getContactList('')"
        :multiple="page == 'filter' ? true : false"
        :no-filter="true"
        attach
        :search-input.sync="searchKeyword"
        :class="page !== 'filter' ? 'required' : ''"
        @input="sendValue"
        :loading="isLoading"
        :rules="page !== 'filter' ? [(v) => !!v || 'Contact is required'] : []"
        :hint="(page === 'edit' && isContactDeleted)? 'Contact has been deleted.': ''"
        :persistent-hint= "true"
      >
        <template v-slot:append-item>
          <div v-intersect="loadMoreContacts" class="teal--text"></div>
        </template>
        <template slot="selection" slot-scope="data">
          <span v-if="page == 'filter'">
            <v-chip
              small
              close
              @click:close="close(data.item, contactTicketId)"
            >
              {{ data.item.first_name | upperCaseFirst }}
              {{ data.item.last_name | upperCaseFirst }}
              <span v-if="data.item.first_name || data.item.last_name">
                -
              </span>
              {{ data.item.email }}
            </v-chip>
          </span>
          <span v-else>
            {{ data.item.first_name | upperCaseFirst }}
            {{ data.item.last_name | upperCaseFirst }}
            <span v-if="data.item.first_name || data.item.last_name"> - </span>
            {{ data.item.email }}
          </span>
        </template>

        <template v-slot:item="{ on, attrs, item }">
          <v-checkbox
            v-on="on"
            class="mt-0 pt-0 pr-1"
            v-bind="attrs"
            v-if="page == 'filter'"
            hide-details
            @click="on.click($event)"
          ></v-checkbox>
          <span v-if="item.first_name || item.last_name">
            {{ item.first_name ? item.first_name : "" | upperCaseFirst }}
            {{ item.last_name ? item.last_name : "" }}
            <span class="grey--text text--darken-2 pl-2">
              {{ item.email | upperCaseFirst }}</span
            >
          </span>
          <span v-else>
            --
            <span class="grey--text text--darken-2 pl-2">{{
              item.email | upperCaseFirst
            }}</span>
          </span>
          <span class="grey--text text--darken-2 pl-2" v-if="page == 'create'">
            {{ item.phone ? item.phone : "" }}</span
          >
        </template>
      </v-autocomplete>
    </div>
  </div>
</template>
<script>
import { $contacts } from "@/services/Index";
export default {
  name: "contact-search",
  props: {
    page: {
      type: String,
    },
    selectedContact: [Number, String, Array],
  },
  data() {
    return {
      contactsPerPage: 10,
      pageNo: 1,
      searchKeyword: null,
      // contactList: [],
      isContactDeleted: false,
      pageCount: null,
      contactTicketId: null,
      isLoading: false,
      contactList: {
        list: [],
        pagination: {},
      },
    };
  },

  watch: {
    searchKeyword(val) {
      this.pageNo = 1;
      if (val && val.length >= 2) {
        let searchVal = val;
        this.getContactList(searchVal);
      }
    },
  },

  mounted() {
    if (
      this.selectedContact !== null &&
      this.selectedContact.toString().length > 0
    ) {
      this.contactTicketId = this.selectedContact;
      this.getContactList(this.selectedContact, true);
    }
    this.getContactList("");
  },

  methods: {
    sendValue() {
      this.$emit("getValue", this.contactTicketId);
      this.isContactDeleted = false
    },

    /** get contact list data from API's */
    getContactList(searchVal = "", initLoad = false) {
      this.isLoading = true;
      const data = {
        per_page: this.contactsPerPage,
        page: this.pageNo,
        q: {
          m: "and",
          g: [
              {
                m: "or",
                first_name_cont: searchVal,
                last_name_cont: searchVal,
                email_cont: searchVal,
                id_in: searchVal,
                phone_cont: searchVal,
              },
              {
                email_does_not_match: "%@pseudonymize.email",
              },
          ],
        },
      };

      $contacts
        .fetchList(data, {})
        .then((response) => {
          // if (action == "scroll") {
          //   this.contactList = [...this.contactList, ...response.data.contacts];
          // } else {
          //   this.contactList = [...response.data.contacts, ...this.contactList];
          // }
          // this.pageCount = response.data.pagination.page_count;
          // this.isLoading = false;

          if (response.data) {
            if (this.pageNo == 1) {
              this.contactList.list = [
                ...response.data.contacts,
                ...this.contactList.list,
              ];
            } else {
              this.contactList.list = [
                ...this.contactList.list,
                ...response.data.contacts,
              ];
            }

            this.contactList.pagination = response.data.pagination;
          }
          if(initLoad){
            // On the initial load, if the contact list does not contain the selected contact ID, then the contact is considered deleted.
            this.isContactDeleted = response.data.contacts.every(contact => contact.id !== this.selectedContact )
          } 
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    // addScrollListener() {
    //   this.selectorClass = ".contacts_dropdown .v-autocomplete__content";
    //   var el = document.querySelector(this.selectorClass);
    //   /** add scroll event **/
    //   if (el) {
    //     el.addEventListener("scroll", this.onScrollTicket);
    //   }
    // },

    // onScrollTicket({ target: { scrollTop, clientHeight, scrollHeight } }) {
    //   if (scrollTop + clientHeight >= scrollHeight) {
    //     if (this.pageNo < this.pageCount) {
    //       this.pageNo = this.pageNo + 1;
    //       this.getContactList("", "scroll");
    //     }
    //   }
    // },

    /** Method to load more contacts and add scroll */
    loadMoreContacts() {
      let existingContact = this.contactList;
      if (
        existingContact &&
        this.pageNo < existingContact.pagination.page_count
      ) {
        this.pageNo += 1;
        this.getContactList();
      }
    },

    /** to delete the selected contact using clear icon in chip under filter drawer section */
    close(el, contactTicketSelData) {
      contactTicketSelData.forEach((value) => {
        if (value == el.id) {
          var index = contactTicketSelData.indexOf(value);
          contactTicketSelData.splice(index, 1);
          this.sendValue();
        }
      });
    },
  },
};
</script>

<style>
.contacts_dropdown .v-input--selection-controls__input > input {
  display: none;
}
.contacts_dropdown .v-messages__message {
  color: red;
}
</style>
